import type { CurrentRefinementsConnectorParamsRefinement } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { useTranslation } from 'next-i18next';
import { ALGOLIA_ATTRIBUTES } from '@shared/utils/src/algolia/algoliaAttributes';
import { Close } from '../../../../icons';
import { sendRemoveCategoryFilterEvent } from '../../../../utils/gtm/events/remove_category_filter/sendRemoveCategoryFilterEvent';
import { Button } from './CurrentRefinement.styles';
import { createRefinementLabel } from './utils/createRefinementLabel';

const FILTER_CATEGORIES = {
  PRICE_RANGE: 'Price Range',
} as const;

type CurrentRefinementItemProps = CurrentRefinementsConnectorParamsRefinement & {
  itemRefine: (value: CurrentRefinementsConnectorParamsRefinement) => void;
};

export function CurrentRefinement({
  refinementItem,
  updateStatusMessage,
}: {
  refinementItem: CurrentRefinementItemProps;
  updateStatusMessage: (msg: string) => void;
}) {
  const { attribute, value, itemRefine } = refinementItem;
  const { label: attributeLabel, value: attributeValue } = createRefinementLabel(attribute, value);
  const { t } = useTranslation(['lib-global-common']);
  const text = attributeLabel ? `${t(attributeLabel)}: ${attributeValue}` : attributeValue;

  const onRemoveRefinement = () => {
    itemRefine(refinementItem);
    sendRemoveCategoryFilterEvent({
      filter_category:
        attribute === ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT ? FILTER_CATEGORIES.PRICE_RANGE : `${t(attributeLabel)}`,
      filter_value: `${attributeValue}`,
    });

    updateStatusMessage(t('applied.filter.removed', { name: text }));
  };

  return (
    <Button
      onClick={onRemoveRefinement}
      data-testid="removeFilter"
      aria-label={t('applied.filters.remove.filter', { name: text })}
    >
      {text}
      <Close viewBox="-3 7 21 10" aria-hidden />
    </Button>
  );
}
